import React, { FC } from 'react';
import Container from '../../../components/Container';
import ToggleSelectAllCheckbox from '../PageTreeToolbar/ToggleSelectAllCheckbox';

// The checkbox sits 14px left of its container (edge='start'). Flat rows are indented 16px; tree rows by the sheet
// padding (8px), the item padding (8px), the expand icon (16px) and the gap after it (8px).
const CHECKBOX_EDGE_PX = 14;
const FLAT_ROW_INDENT_PX = 16;
const TREE_ROW_INDENT_PX = 40;

interface ImportedSelectionHeaderProps {
  inTree: boolean;
}

/** Header row above the imported list; its checkbox lines up with the checkboxes of the rows below. */
export const ImportedSelectionHeader: FC<ImportedSelectionHeaderProps> = ({ inTree }) => (
  <Container
    fullWidth
    left
    pl={`${(inTree ? TREE_ROW_INDENT_PX : FLAT_ROW_INDENT_PX) + CHECKBOX_EDGE_PX}px`}
    sx={{ mb: 1, borderBottom: (theme) => `1px solid ${theme.palette.divider}` }}>
    <ToggleSelectAllCheckbox />
  </Container>
);

export default ImportedSelectionHeader;
